import { render } from "./BargraphEditor.vue?vue&type=template&id=296b9235&scoped=true"
import script from "./BargraphEditor.vue?vue&type=script&lang=js"
export * from "./BargraphEditor.vue?vue&type=script&lang=js"

import "./BargraphEditor.vue?vue&type=style&index=0&id=296b9235&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296b9235"]])

export default __exports__